import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import {
  getContactsQueryKey,
  listContacts,
  type ListContactsFilters,
} from '../api/contacts.client.js';

export function useContacts(filters: ListContactsFilters = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getContactsQueryKey(workspaceId, filters),
    queryFn: () => listContacts(filters),
    enabled: scope !== null,
    // Фильтры считает сервер: без этого каждая смена фильтра или буква поиска
    // роняла таблицу в скелетон вместо того, чтобы обновить её на месте.
    placeholderData: keepPreviousData,
  });
}
